module.exports = __webpack_public_path__ + "06da59d283aa3d56081830dc63335138.jpg";